export default __webpack_public_path__ + "static/cta-pescatarian-2-90ccd80b6c93e16f07fa4270c17f4bdc.jpg";